import { render, staticRenderFns } from "./LightboxModal.vue?vue&type=template&id=1fe6dba7&scoped=true"
import script from "./LightboxModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LightboxModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LightboxModal.vue?vue&type=style&index=0&id=1fe6dba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6dba7",
  null
  
)

export default component.exports